export var ContentDirection;
(function (ContentDirection) {
    ContentDirection["LTR"] = "ltr";
    ContentDirection["RTL"] = "rtl";
})(ContentDirection || (ContentDirection = {}));
